import * as React from 'react';

export const GoogleColor: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
			<g id="Icon / Social-Media / Google-OG">
				<g id="Vector">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M4.99872 9.80164C4.99872 9.27323 5.08649 8.76663 5.24312 8.29147L2.50141 6.1978C1.96707 7.28272 1.66602 8.5052 1.66602 9.80164C1.66602 11.097 1.9667 12.3187 2.5003 13.4029L5.24053 11.3051C5.08538 10.8322 4.99872 10.3275 4.99872 9.80164Z"
						fill="#FBBC05"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M9.81277 4.99449C10.9607 4.99449 11.9975 5.40124 12.8122 6.06684L15.1821 3.70027C13.738 2.44303 11.8865 1.6665 9.81277 1.6665C6.59337 1.6665 3.82635 3.50768 2.50141 6.1978L5.24312 8.29147C5.87486 6.37382 7.67576 4.99449 9.81277 4.99449Z"
						fill="#EA4335"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M9.81277 14.6086C7.67576 14.6086 5.87499 13.2294 5.24325 11.3117L2.50154 13.405C3.82648 16.0955 6.59337 17.9366 9.81277 17.9366C11.7998 17.9366 13.6969 17.2311 15.1207 15.9091L12.5182 13.8972C11.7839 14.3598 10.8592 14.6086 9.81277 14.6086Z"
						fill="#34A853"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M17.5888 9.8016C17.5888 9.32089 17.5148 8.8032 17.4037 8.3225H9.8125V11.4656H14.182C13.9636 12.5372 13.3691 13.361 12.5182 13.8972L15.1207 15.9091C16.6163 14.521 17.5888 12.4533 17.5888 9.8016Z"
						fill="#4285F4"
					/>
				</g>
			</g>
		</svg>
	);
};
